import { URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const bomApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadBom: builder.mutation({
      /**
       * 上传 BOM 文件并解析匹配。
       * @param {FormData} formData 上传表单
       * @returns {{url: string, method: string, body: FormData}}
       */
      query: (formData) => ({
        url: `${URL}/bom/upload`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Bom"],
    }),

    getBomOrder: builder.query({
      /**
       * 获取 BOM 任务详情。
       * @param {{id: string, sessionId: string}} params 查询参数
       * @returns {{url: string, method: string, params: Object}}
       */
      query: ({ id, sessionId }) => ({
        url: `${URL}/bom/${id}`,
        method: "GET",
        params: sessionId ? { sessionId } : undefined,
      }),
      providesTags: ["Bom"],
    }),

    updateBomItem: builder.mutation({
      /**
       * 更新 BOM 明细数量、选择状态或匹配商品。
       * @param {{bomId: string, itemId: string, sessionId: string, payload: Object}} params 更新参数
       * @returns {{url: string, method: string, body: Object}}
       */
      query: ({ bomId, itemId, sessionId, payload }) => ({
        url: `${URL}/bom/${bomId}/items/${itemId}`,
        method: "PATCH",
        body: {
          ...payload,
          sessionId,
        },
      }),
      invalidatesTags: ["Bom"],
    }),

    rematchBom: builder.mutation({
      /**
       * 重新匹配 BOM 任务。
       * @param {{bomId: string, sessionId: string}} params 重新匹配参数
       * @returns {{url: string, method: string, body: Object}}
       */
      query: ({ bomId, sessionId }) => ({
        url: `${URL}/bom/${bomId}/rematch`,
        method: "POST",
        body: { sessionId },
      }),
      invalidatesTags: ["Bom"],
    }),

    buildBomCartItems: builder.mutation({
      /**
       * 获取可写入购物车的 BOM 商品项。
       * @param {{bomId: string, sessionId: string, itemIds: string[]}} params 加购参数
       * @returns {{url: string, method: string, body: Object}}
       */
      query: ({ bomId, sessionId, itemIds }) => ({
        url: `${URL}/bom/${bomId}/cart-items`,
        method: "POST",
        body: { sessionId, itemIds },
      }),
    }),
  }),
});

export const {
  useUploadBomMutation,
  useGetBomOrderQuery,
  useUpdateBomItemMutation,
  useRematchBomMutation,
  useBuildBomCartItemsMutation,
} = bomApi;
